import { css } from '@emotion/react';
import styled from '@emotion/styled';
import cns from 'classnames';
import { BaseHTMLAttributes } from 'react';
import { space, SpaceProps } from 'styled-system';
import { MapUiSize, MAPUI_SIZES } from '../../common/types';

export const CARD_CLASSNAME = '__mapui_card';

export const CARD_SIZES = MAPUI_SIZES;

const applyMainStyles =
  ({ size }: Pick<CardProps, 'size'>) =>
  (theme) => {
    const defaultStyle = css(theme.card.defaultStyles);
    const sizeStyle = css(theme.card[size]);

    const styles = [defaultStyle, sizeStyle];

    return css(...styles);
  };

export interface CardProps
  extends BaseHTMLAttributes<HTMLDivElement>,
    SpaceProps {
  size?: MapUiSize;
}

export const Card = styled.div<CardProps>(
  ({ theme, size = 'md' }) => ({
    ...applyMainStyles({ size })(theme),
  }),
  ({ className }) => ({
    className: cns(CARD_CLASSNAME, className),
  }),
  space
);
